// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Modal_modalOverlay__Bo5+Y","modalContent":"Modal_modalContent__5iIEb","closeBtn":"Modal_closeBtn__6EdpV"};